import type { LibraryContext } from "@/native-shell/library";
import { WIDGET_CHANGED } from "./widget-bridge";

export const WIDGET_STATUS_CHANGED = "peakwave-widget-status";
type WidgetStatus = { state: "idle" | "refreshing" | "saved" | "off" | "error"; checkedAt: number | null };
const initial: WidgetStatus = { state: "idle", checkedAt: null };
let status = initial;
let conditions: (LibraryContext & { slug: string | null }) | null = null;
export function widgetStatus(): WidgetStatus { return status; }
export function initialWidgetStatus(): WidgetStatus { return initial; }
export function setWidgetStatus(state: WidgetStatus["state"]) {
  status = { state, checkedAt: state === "saved" ? Date.now() : null };
  window.dispatchEvent(new Event(WIDGET_STATUS_CHANGED));
}
export function subscribeWidgetStatus(listener: () => void) { window.addEventListener(WIDGET_STATUS_CHANGED, listener); return () => window.removeEventListener(WIDGET_STATUS_CHANGED, listener); }
export function widgetConditionsSource(context: LibraryContext): string | null {
  return conditions?.owner === context.owner && conditions.generation === context.generation ? conditions.slug : null;
}
export function setWidgetConditionsSource(context: LibraryContext, slug: string | null) {
  conditions = { ...context, slug };
  window.dispatchEvent(new Event(WIDGET_CHANGED));
}
export function clearWidgetConditionsSource() { conditions = null; }
